export type SessionRestoreStatus = 'none' | 'active' | 'expired';

export function isSessionExpired(expiresAt: string, now = Date.now()): boolean {
  if (!expiresAt) return false;
  const ts = Date.parse(expiresAt);
  return Number.isFinite(ts) && ts <= now;
}

export function resolveRestoredSession(
  token: string,
  expiresAt: string,
  now = Date.now(),
): { expiresAt: string; status: SessionRestoreStatus; token: string } {
  if (!token) return { expiresAt: '', status: 'none', token: '' };
  if (isSessionExpired(expiresAt, now)) {
    return { expiresAt: '', status: 'expired', token: '' };
  }
  return { expiresAt, status: 'active', token };
}
